<template>
  <DossierOperationalBase :config="config" />
</template>

<script>
import DossierOperationalBase from "../dossier/operational/DossierOperationalBase.vue";

export default {
  name: "DossierMenu",

  components: { DossierOperationalBase },

  data() {
    return {
      config: {
        // ── Identidade ─────────────────────────────────────────────────────
        moduleKey: "menu",
        title: "Cardápios",
        subtitle:
          "Registro e controle dos cardápios por período, refeição ou dieta",
        icon: "fas fa-utensils",
        itemName: "cardápio",
        addLabel: "Novo cardápio",
        namePlaceholder: "Ex: Cardápio semanal – Janeiro 2025",
        explainer:
          "Registre os cardápios da instituição. Cada cardápio deve conter " +
          "o período de vigência, o tipo (refeição, dieta ou turno), o " +
          "profissional responsável (nutricionista) e o arquivo PDF com o " +
          "cardápio detalhado. O sistema controla automaticamente quais " +
          "cardápios estão vigentes, futuros ou encerrados.",

        // ── Tipos disponíveis ──────────────────────────────────────────────
        typeOptions: [
          "Cardápio geral",
          "Dieta hipossódica",
          "Dieta hipocalórica",
          "Dieta diabética",
          "Dieta para disfagia",
          "Dieta pastosa",
          "Dieta líquida",
          "Cardápio de desjejum",
          "Cardápio de lanche",
          "Cardápio de almoço",
          "Cardápio de jantar",
          "Cardápio semanal",
          "Cardápio mensal",
          "Outros",
        ],

        // ── Permissões ─────────────────────────────────────────────────────
        writePermission: "dossier_write",
        readPermission: "dossier_read",

        // ── Endpoints ──────────────────────────────────────────────────────
        listEndpoint: "/rest-home/dossier/menu",
        saveEndpoint: "/rest-home/dossier/menu",
        uploadEndpoint: "/rest-home/dossier/menu/upload",
        deleteEndpoint: "/rest-home/dossier/menu",
      },
    };
  },
};
</script>